import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Panel from '../Panel';
import LoadingBlinker from '../LoadingBlinker';
import OAuthAPI from '../../lib/OAuthAPI';
import OAuthSignIn from './OAuthSignIn';

function errorMessage(error) {
	return error && error.response && error.response.data && error.response.data.error_description
		? error.response.data.error_description
		: 'This authorization request could not be validated.';
}

function OAuthAuthorize() {
	let location = useLocation();
	let [authorization, setAuthorization] = useState(null);
	let [error, setError] = useState(null);

	let load = () => {
		let params = Object.fromEntries(new URLSearchParams(location.search).entries());
		setError(null);
		OAuthAPI.getAuthorization(params).then(setAuthorization).catch(requestError => setError(errorMessage(requestError)));
	};

	useEffect(load, [location.search]);

	if(error) return <Panel className="oauth-panel"><h2>Authorization unavailable</h2><p className="validation-text">{error}</p></Panel>;
	if(!authorization) return <Panel className="oauth-panel"><LoadingBlinker text="Checking authorization request" /></Panel>;
	if(!authorization.signed_in) return <Panel className="oauth-panel"><OAuthSignIn onSignedIn={load} sport={authorization.sport} /></Panel>;

	let request = authorization.request;
	let client = authorization.client;
	let csrf = OAuthAPI.getCsrf();
	return (
		<Panel className="oauth-panel">
			<div className="oauth-consent">
				<h2>Authorize {client.Name}</h2>
				<p>{client.Description}</p>
				<p><strong>Developer:</strong> <a href={client.HomepageUrl} target="_blank" rel="noopener noreferrer">{client.HomepageUrl}</a></p>
				<p><strong>Sport:</strong> {authorization.sport === 'football' ? 'Blackout Football' : 'Blackout Rugby'}</p>
				<h3>This app is requesting</h3>
				<ul>
					{authorization.scopes.map(scope => <li key={scope.scope} className={`oauth-scope-risk-${scope.risk}`}><strong>{scope.label}</strong>{scope.risk === 'high' ? ' — includes purchases or irreversible actions.' : scope.risk === 'write' ? ' — can make changes to your game data.' : ''}</li>)}
				</ul>
				{authorization.scopes.some(scope => scope.risk === 'high') ? <p className="oauth-warning">This includes commerce or irreversible access. Review it carefully before allowing.</p> : null}
				<form method="post" action={OAuthAPI.authorizationFormAction()}>
					{Object.entries(request).map(([key, value]) => value !== null ? <input key={key} type="hidden" name={key} value={value} /> : null)}
					<input type="hidden" name="csrf_token" value={csrf || ''} />
					<div className="oauth-actions">
						<button className="loader-button oauth-deny" type="submit" name="decision" value="deny">Deny</button>
						<button className="loader-button" type="submit" name="decision" value="allow">Allow access</button>
					</div>
				</form>
				<p className="oauth-fine-print">You can revoke access later from Authorized apps.</p>
			</div>
		</Panel>
	);
}

export default OAuthAuthorize;
